import { ImageType, IPDPMediaItem, IPDPVendorLogoMediaItem, MediaType } from './pdp-media-item.model';
import { IPDPPCBDetails } from './pdp-pcb-details.model';

export interface IPDPMedia {
  disclaimerMessage: string;
  media: (IPDPMediaItem | IPDPPCBDetails)[];
  mediaUrl: string;
  showPCBFootprint: boolean;
  pcbFootprintParameters?: IPDPPCBDetails | null;
  vendorLogo?: IPDPVendorLogoMediaItem | null;
  isZoomEnabled: boolean;
}

export function isPDPMediaItem(object: IPDPMediaItem | IPDPPCBDetails): object is IPDPMediaItem {
  return (object as IPDPMediaItem).mediaType !== undefined;
}

export function getPrimaryImageUrl(mediaArea: IPDPMedia, width?: number, size?: string): IPDPMediaItem | undefined {
  let mediaItem = mediaArea.media.find((m) => isPDPMediaItem(m) && m.imageType === ImageType.PrimaryImage);
  if (mediaItem && isPDPMediaItem(mediaItem)) {
    if ((width || size) && mediaItem.id !== 'noImage') {
      const newMediaItem = { ...mediaItem };

      if (width) {
        newMediaItem.url = mediaArea?.mediaUrl.replace(/\[width\]/g, width.toString()).replace('[name]', mediaItem.name);
      } else if (size) {
        newMediaItem.url = process.env.REACT_APP_MEDIA_ENDPOINT?.replace('[size]', size).replace('[name]', mediaItem.name) ?? '';
      }
      return newMediaItem;
    }
    return mediaItem;
  }
}

export function getThumbnail(mediaItem: IPDPMediaItem, mediaArea: IPDPMedia, size: string = 'medium') {
  return mediaItem.mediaType === MediaType.Image
    ? getImageThumbnail(mediaItem)
    : mediaItem.mediaType === MediaType.YoutubeVideo
    ? `https://img.youtube.com/vi/${mediaItem.name}/default.jpg`
    : mediaItem.mediaType === MediaType.View_3D
    ? getPrimaryImageUrl(mediaArea, undefined, size)?.url
    : '';
}

function getImageThumbnail(media: IPDPMediaItem): string {
  return media.id === 'noImage' ? media.url : media.thumbnailUrl;
}
